module.exports = __webpack_public_path__ + "static/media/sipec03.c436cb30.png";